/* eslint semi:0 */
import React from 'react'
import { connect } from 'react-redux'
import reduxMount from '../../jsCore/utils/reduxMounter'
import { fanvoiceReducer } from './fanvoiceReducer'
import { fanvoiceActions } from './fanvoiceActions'
import { t } from '../../jsCore/providers/i18nProvider/i18nProvider'
import { FanvoiceList } from './components/fanvoiceList'
import { FanvoiceItem } from './components/fanvoiceItem'
import { FanvoiceTitle } from './components/fanvoiceTitle'
import { FanvoiceWrapper } from './components/fanvoiceWrapper'
import { MOUNT_POINTS } from '../../jsCore/config/preRenderedSelectorsConfig'
import { isSupportedForDomain } from '../../jsCore/application/pageDataObject'
import { getNoEndpointsErrorMessage } from '../../jsCore/application/sagas/fetchSaga'
import { FanvoiceAuthorDetails } from './components/fanvoiceAuthorDetails'
import { FanvoiceItemPlaceholder } from './components/fanvoiceItemPlaceholder'
import { FanvoiceItemDescription } from './components/fanvoiceItemDescription'

const FANVOICE_FEATURE_ID = 'Fanvoice'
const COMPONENT_NAME = 'fanvoiceContainer'
const STATE_KEY = 'fanvoice'

export class fanvoiceComponent extends React.Component {
  componentWillMount() {
    const { fetchFanvoice, IS_ENTRY_POINT_MISSING } = this.props
    if (!IS_ENTRY_POINT_MISSING) {
      fetchFanvoice()
    } else {
      getNoEndpointsErrorMessage(this)
    }
  }

  getFanvoiceItem(item, key) {
    const { image, type, content, author } = item
    const itemPlaceHolderProps = { key, image, type }
    return (
      <FanvoiceItemPlaceholder {...itemPlaceHolderProps}>
        <FanvoiceItem itemData={item}>
          {content ? <FanvoiceItemDescription content={content} /> : false}
          {author ? <FanvoiceAuthorDetails author={author} /> : false}
        </FanvoiceItem>
      </FanvoiceItemPlaceholder>
    )
  }

  getItems(fanvoiceItems) {
    return fanvoiceItems.map(this.getFanvoiceItem)
  }

  getFanvoiceList() {
    const { IS_INITIALIZED, emptyPlaceholdersCount, fanvoiceItems } = this.props
    if (!IS_INITIALIZED) {
      return Array.from(emptyPlaceholdersCount, (_, index) => (
        <FanvoiceItemPlaceholder key={index} isEmpty={true} />
      ))
    }
    return this.getItems(fanvoiceItems)
  }

  render() {
    return (
      <FanvoiceWrapper>
        <FanvoiceTitle text={t('homepage.fan_voice')} />
        <FanvoiceList>{this.getFanvoiceList()}</FanvoiceList>
      </FanvoiceWrapper>
    )
  }
}

function mapStateToProps(state) {
  const { emptyPlaceholdersCount, IS_INITIALIZED, fanvoiceItems, IS_ENTRY_POINT_MISSING } = state[
    STATE_KEY
  ]
  return {
    emptyPlaceholdersCount,
    IS_INITIALIZED,
    fanvoiceItems,
    IS_ENTRY_POINT_MISSING,
  }
}

const fanvoiceContainer = {
  name: COMPONENT_NAME,
  stateKey: STATE_KEY,
  component: connect(mapStateToProps, fanvoiceActions)(fanvoiceComponent),
  reducer: fanvoiceReducer,
}

function mountFanvoice() {
  return reduxMount({
    [MOUNT_POINTS.FANVOICE_CONTAINER]: fanvoiceContainer,
  })
}

export default function initFanvoice() {
  const shouldMountFanvoice = isSupportedForDomain(FANVOICE_FEATURE_ID)
  if (shouldMountFanvoice) {
    mountFanvoice()
  }
  return shouldMountFanvoice
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/fanvoice/fanvoiceContainer.js